export default "__VITE_ASSET__D9G2rv$h__"